import HttpService from '@/common/services/HttpService'
import type {
  ScreenBaseDTOV1,
  ScreenBaseDTOV2,
  ScreenBaseDTOV3,
  ScreenDTOV1,
  ScreenDTOV2,
  ScreenTypeEnum,
  ScreenField,
  ListScreensParamsV1,
  FieldConditionCollection,
  FieldConditionListDTOV1,
  FieldConditionDTOV1,
} from '@/common/types/screen'
/**
 * Retrieve all screens of the requested types
 * @param params
 * @returns screens list
 * @deprecated
 */
export const getScreensV1 = async (params: ListScreensParamsV1): Promise<ScreenBaseDTOV1[]> => {
  return HttpService.getData<ScreenBaseDTOV1[]>('/api/v1/screens', {
    params: {
      ...params,
      /**
       * Convert type parameter from ScreenTypeEnum[] to string
       * API expects a string even if API contract mentionned string[]
       */
      types: params.types?.join(),
    },
  })
}

export const getScreensV3 = async (): Promise<ScreenBaseDTOV3[]> => {
  return HttpService.getData<ScreenBaseDTOV3[]>('/api/v3/screens', {
    params: {
      'include-deactivated': true,
    },
  })
}

/**
 * Get screen by id
 * @deprecated
 * @param id screen id
 * @returns ScreenDTOV1
 */
export const getScreenById = async (id: number): Promise<ScreenDTOV1> => {
  return HttpService.getData<ScreenDTOV1>('/api/v1/screens/' + id)
}

/**
 * Handle screen activation
 */
export const handleScreenActivation = (code: UUID, active: boolean) => {
  return HttpService.patch(`/api/v2/screens/${code}`, {
    activeToSet: active,
  })
}

/**
 * Get screen by code
 * @param screenCode screen code
 * @returns ScreenDTOV2
 */
export const getScreenByCode = async (screenCode: UUID): Promise<ScreenDTOV2> => {
  return HttpService.getData<ScreenDTOV2>(`/api/v2/screens/${screenCode}`)
}

/**
 * Create new screen
 * @returns created screen
 */
export const createScreen = async (newScreen: { type: ScreenTypeEnum; active: boolean; fields: ScreenField[] }): Promise<ScreenBaseDTOV2> => {
  return HttpService.postData<ScreenBaseDTOV2>('/api/v2/screens', newScreen)
}

/**
 * Update existing screen
 * @returns updated screen
 */
export const updateScreen = async (screenCode: UUID, updateScreenPayload: { active: boolean; fields: ScreenField[] }): Promise<ScreenBaseDTOV2> => {
  return HttpService.putData<ScreenBaseDTOV2>(`/api/v2/screens/${screenCode}`, updateScreenPayload)
}

/**
 * Get screen by code
 * @param screenCode screen code
 * @returns ScreenDTOV2
 */
export const getScreenFieldConditions = async (screenCode: UUID): Promise<FieldConditionCollection> => {
  const conditions = await HttpService.getData<FieldConditionListDTOV1>(`/api/v1/screens/${screenCode}/fields-display-conditions`, { raw: true })
  return new Map([...conditions.map((c) => [c.targetFieldCode, c] as [string, FieldConditionDTOV1])])
}
